import React, { Fragment } from 'react';
import { Filter, SelectInput, TextInput, List, Edit, Datagrid, TextField,
         ReferenceField, DateInput, EditButton, Responsive,
 } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Divider from '@material-ui/core/Divider';
import Tabs from '@material-ui/core/Tabs';
import TabUp from '@material-ui/core/Tab';
import moment from "moment";

const tourCats = [
  { _id: 1, description: 'Imt Tours' },
  { _id: 2, description: 'Imt Custom Tours' },
  { _id: 3, description: 'Globals Tours' },
];

const filterStyles = {
    status: { width: 150 },
};

const datagridStyles = {
    total: { fontWeight: 'bold' },
};

class TabbedDatagrid extends React.Component {



    tabs = [
        { id: '1', name: 'Tours' },
        { id: '2', name: 'Rentals' },
    ];

    state = { tour: [], rental: [] };

    static getDerivedStateFromProps(props, state) {
        if (props.ids !== state[props.filterValues.booking_type]) {
            return { ...state, [props.filterValues.booking_type]: props.ids };
        }
        return null;
    }

    handleChange = (event, value) => {
        const { filterValues, setFilters } = this.props;
        setFilters({ ...filterValues, booking_type: value });
    };

    render() {
        const { classes, filterValues, ...props } = this.props;
        return (
            <Fragment>
                <Tabs
                    fullWidth
                    centered
                    value={filterValues.booking_type}
                    indicatorColor="primary"
                    onChange={this.handleChange}
                >
                    {this.tabs.map(choice => (
                        <TabUp
                        translateChoice={false}
                            key={choice.id}
                            label={choice.name}
                            value={choice.id}
                        />
                    ))}
                </Tabs>
                <Divider />
                <Responsive
                    medium={
                        <div>

                            {filterValues.booking_type === '1' && (
                                <Datagrid
                                    {...props}
                                    ids={this.state['1']}
                                >
                                <TextField source="tour_id" />
                                <ReferenceField  label="Tour" source="tour_id" reference="tours" linkType={false} filter={{ only_tour: 'true' }} >
                                  <ReferenceField sortBy="tour.name" label="Tour Name" source="tour_name_id" reference="tour_names" linkType={false} filter={{ only_tour: 'true' }} >
                                    <TextField source="tour_name_en" />
                                  </ReferenceField>
                                  </ReferenceField>

                                    <EditButton />
                                </Datagrid>
                            )}

                            {filterValues.booking_type === '2' && (
                                <Datagrid
                                    {...props}
                                    ids={this.state['2']}
                                >
                                    <TextField label="id" source="id" />
                                    <EditButton />
                                </Datagrid>
                            )}
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

const StyledTabbedDatagrid = withStyles(datagridStyles)(TabbedDatagrid);

function Fecha(date){
    return moment.utc(date).locale('es').format('YYYY-MM-DD');
  }

const CommandFilter = withStyles(filterStyles)(({ classes, ...props }) => (
    <Filter {...props}>
        <DateInput label="Tour Begin Date" source="begin_date"  locales="es-Es" options={{ timeZone: 'UTC' }}  format={Fecha} alwaysOn />
        <DateInput label="Tour End Date" source="end_date"  locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
        <TextInput label="Tour Name" source="tour_name" alwaysOn />
        <SelectInput label="Tour Category" source="tour_category_id" choices={tourCats} optionText="description" optionValue="_id" defaultValue={{ tour_category_id: '1' }} translateChoice={false} />
    </Filter>
));

export const BookingList = ({ classes, ...props }) => (
    <List
        {...props}
        filterDefaultValues={{ booking_type: '1', tour_category_id: '1' }}
        sort={{ field: 'id', order: 'DESC' }}
        perPage={10}
        filters={<CommandFilter />}
        bulkActionButtons={false}
    >
        <StyledTabbedDatagrid />
    </List>
);

const BookingTitle = (object) => (
    <span>
        {' Edit '} &quot;{
            object.record.licence_plate
        }&quot;
    </span>
);

export const BookingEdit = props => (
    <Edit title={<BookingTitle />} {...props}>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/resources/bookings.js